import React from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import Stripe from "../components/Stripe";
import { useLocation } from "react-router-dom";
const Payment = () => {
  const {
    state: { price, items, orderId },
  } = useLocation();
  return (
    <div>
      <Headers />
      <section className="bg-primaryBackground">
        <div className="w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-16 ">
          <div className="flex flex-wrap md:flex-col-reverse">
            <div className="w-7/12 md:w-full">
              <div className="pr-2 md:pr-0">
                <div className="flex flex-wrap "></div>
                <div>
                  <Stripe orderId={orderId} price={price} />
                </div>
              </div>
            </div>
            <div className="w-5/12 md:w-full ">
              <div className="pl-2 md:pl-0 md:mb-0">
                <div className="bg-white rounded-lg shadow p-5 text-slate-600 flex flex-col gap-3">
                  <h2>Order Summary</h2>
                  <div className="flex justify-between items-center">
                    <span>{items} items and shipping fee included</span>
                  </div>
                  <div className="flex justify-between items-center font-semibold">
                    <span>Total Amount</span>
                    <span className="text-lg text-rose-500">Rs.{price}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Payment;
